import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { formatApiError } from "../../lib/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(form.email, form.password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  const fieldCls = "w-full bg-[#0B132B] border border-[#1E293B] rounded-md px-4 py-3 text-sm text-slate-100 placeholder:text-slate-500 focus:outline-none focus:border-[#F97316] focus:ring-1 focus:ring-[#F97316] transition-colors";

  return (
    <div className="min-h-[80vh] bg-[#0B132B] flex items-center justify-center px-4" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-sm bg-[#131C38] border border-[#1E293B] rounded-lg p-8" data-testid="admin-login-form">
        <div className="w-12 h-12 rounded-md bg-[#F97316]/10 border border-[#F97316]/25 flex items-center justify-center text-[#F97316] mb-6">
          <Lock className="w-5 h-5" />
        </div>
        <h1 className="font-display text-2xl font-bold text-white mb-1">Admin Panel</h1>
        <p className="text-xs text-slate-400 mb-6">Sign in to manage services, blogs and leads.</p>
        <div className="space-y-4">
          <input type="email" required value={form.email} data-testid="admin-login-email"
            onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="Email" className={fieldCls} />
          <input type="password" required value={form.password} data-testid="admin-login-password"
            onChange={(e) => setForm({ ...form, password: e.target.value })} placeholder="Password" className={fieldCls} />
          {error && <p className="text-sm text-red-400" data-testid="admin-login-error">{error}</p>}
          <button type="submit" disabled={loading} data-testid="admin-login-submit"
            className="w-full bg-[#F97316] hover:bg-[#EA580C] disabled:opacity-60 text-[#0B132B] font-bold text-sm px-6 py-3 rounded-md transition-colors flex items-center justify-center gap-2">
            {loading && <Loader2 className="w-4 h-4 animate-spin" />} Sign In
          </button>
        </div>
      </form>
    </div>
  );
}
